import {
    ExtractFeaturesReturnType,
    ListingFeaturesFragment
} from './ListingFeatures.types';

// GraphQL response is still using the same structure as Raiden LDP. Once new LDP is stable
// we plan to move this response manipulation to the GraphQL endpoint so this can be removed.
//
// See https://zpgltd.atlassian.net/browse/LEX-145
export const extractFeaturesFromQueryResponse = ({
    features
}: ListingFeaturesFragment): ExtractFeaturesReturnType => {
    if (!features) {
        return {
            features: [],
            highlights: []
        };
    }

    const standardFeatures = features.bullets || [];
    const highlightedFeatures =
        features.highlights &&
        features.highlights.map((highlight) => highlight.label);
    const flaggedFeatures: string[] = [];

    if (features.flags) {
        const { furnishedState, studentFriendly, tenure } = features.flags;

        if (furnishedState) {
            flaggedFeatures.push(furnishedState.label);
        }

        if (studentFriendly) {
            flaggedFeatures.push('Student friendly');
        }
        if (tenure) {
            flaggedFeatures.push(tenure.label);
        }
    }

    return {
        features: [...flaggedFeatures, ...standardFeatures],
        highlights: highlightedFeatures || []
    };
};
